import editItem from "./editItem"

export default {
    "type": "array",
    "items": editItem,
    "maxItems": 1
}